export const languageMap = {
  english: {
    emailPlaceholder: 'Enter your email',
    formHeader: 'Apply below & we’ll get back to you👇',
    personalInfoHeader: '✍️ PERSONAL INFORMATION',
    socialMediaHeader: '🔗 SOCIAL MEDIA LINKS',
    ambassadorQuestionHeader: '💬 Answer these questions',
    shippingAddressHeader: '🏠 SHIPPING ADDRESS FOR GIFTS',
    paymentDetailsHeader: '💰 PAYMENT DETAILS TO SEND COMMISSIONS',
    paymentDetailsSubTitle: 'Select payment method and enter email address?',
    firstNameLabel: 'First Name',
    lastNameLabel: 'Last Name',
    emailAddressLabel: 'Email Address',
    addressLabel: 'Address',
    apartmentLabel: 'Apartment, suite, etc',
    postalCodeLabel: 'Postal Code',
    cityLabel: 'City',
    stateLabel: 'State',
    countryLabel: 'Country',
    phoneLabel: 'Phone (Optional)',
    chooseProductHeader: '🎁 CHOOSE PRODUCTS FOR GIFTS',
    chooseProductSubTitle: 'Pick your favorite from these gift options!',
    selectProductLabel: 'Select Product*',
    selectProductPlaceholder: 'Select an option',
    otherDetailsHeader: '✨ OTHER DETAILS',
    otherDetailsSubTitle: "Anything else you'd expect from the ambassador program?",
    otherDetailsPlaceholder: 'Please answer the above...',
    goBackToStoreCta: 'Go back to the store',
    submitApplicationCta: 'Submit Application',
    paypalPlaceholder: 'Your PayPal email',
    venmoPlaceholder: 'Your Venmo email',
    invalidPaypalEmail: 'Please enter a valid PayPal email',
    invalidVenmoEmail: 'Please enter a valid Venmo email',
    applyNowCta: 'Apply Now!',
    addressPlaceholder: 'e.g. Empire State Building',
    apartmentPlaceholder: 'e.g. 10th floor',
    postalCodePlaceholder: 'e.g. 10001',
    cityPlaceholder: 'e.g. New York',
    statePlaceholder: 'e.g. New York',
    countryPlaceholder: 'e.g. United States of America',
    usernamePlaceholder: 'username',
    addressLineOneMinLengthError: 'Address must be at least 4 characters',
    addressLineOneMaxLengthError: 'Max character limit reached.',
    applicationAlreadySubmittedHeader: 'You’ve Already Applied',
    applicationAlreadySubmittedSubTitle:
      'We’ve already received your application. If there are any updates, we will reach out to you soon.',
  },
  french: {
    emailPlaceholder: 'Entrez votre email',
    formHeader: 'Veuillez remplir le formulaire ci-dessous et on vous contactera👇',
    personalInfoHeader: '✍️ INFORMATIONS PERSONNELLES',
    socialMediaHeader: '🔗 Réseaux Sociaux',
    ambassadorQuestionHeader: '💬 à remplir',
    shippingAddressHeader: '🏠 ADRESSE DE LIVRAISON POUR LES CADEAUX',
    paymentDetailsHeader: '💰 DÉTAILS DE PAIEMENT POUR ENVOYER DES COMMISSIONS',
    paymentDetailsSubTitle: "Sélectionnez le mode de paiement et saisissez l'adresse e-mail ?",
    firstNameLabel: 'Prénom',
    lastNameLabel: 'Nom de famille',
    emailAddressLabel: 'Adresse e-mail',
    addressLabel: 'Adresse',
    apartmentLabel: 'Appartement, suite, etc',
    postalCodeLabel: 'Code postal',
    cityLabel: 'Ville',
    stateLabel: 'État',
    countryLabel: 'Pays',
    phoneLabel: 'Téléphone (facultatif)',
    chooseProductHeader: '🎁 CHOISISSEZ DES PRODUITS POUR CADEAUX',
    chooseProductSubTitle: 'Choisissez votre favori parmi ces options de cadeaux !',
    selectProductLabel: 'Sélectionner un produit*',
    selectProductPlaceholder: 'Choisir une option',
    otherDetailsHeader: '✨ AUTRES DÉTAILS',
    otherDetailsSubTitle: 'Y a-t-il autre chose que vous attendez du programme des ambassadeurs ?',
    otherDetailsPlaceholder: 'Veuillez répondre à la question ci-dessus...',
    goBackToStoreCta: 'Retourner au magasin',
    submitApplicationCta: 'Envoyer',
    paypalPlaceholder: 'Votre email PayPal',
    venmoPlaceholder: 'Votre email Venmo',
    invalidPaypalEmail: 'Veuillez saisir une adresse e-mail PayPal valide',
    invalidVenmoEmail: 'Veuillez saisir une adresse e-mail Venmo valide',
    applyNowCta: 'Appliquer maintenant!',
    addressPlaceholder: 'e.g. Hôtel France Eiffel',
    apartmentPlaceholder: 'e.g. 10ème étage',
    postalCodePlaceholder: 'e.g. 75007',
    cityPlaceholder: 'e.g. Paris',
    statePlaceholder: 'e.g. Paris',
    countryPlaceholder: 'e.g. France',
    usernamePlaceholder: "nom d'utilisateur",
    addressLineOneMinLengthError: "L'adresse doit comporter au moins 4 caractères",
    addressLineOneMaxLengthError: 'Limite maximale de caractères atteinte.',
    applicationAlreadySubmittedHeader: 'Candidature déjà soumise !',
    applicationAlreadySubmittedSubTitle: 'Vous avez déjà soumis la candidature.',
  },
  german: {
    emailPlaceholder: 'Geben Sie Ihre E-Mail-Adresse ein',
    formHeader: 'Bewerben Sie sich unten und wir melden uns bei Ihnen👇',
    personalInfoHeader: '✍️ PERSÖNLICHE INFORMATIONEN',
    socialMediaHeader: '🔗 SOCIAL-MEDIA-LINKS',
    ambassadorQuestionHeader: '💬 FRAGEN ZUM AMBASSADOR-PROGRAMM',
    shippingAddressHeader: '🏠 VERSANDADRESSE FÜR GESCHENKE',
    paymentDetailsHeader: '💰 ZAHLUNGSDETAILS ZUM SENDEN VON PROVISIONEN',
    paymentDetailsSubTitle: 'Zahlungsmethode auswählen und E-Mail-Adresse eingeben?',
    firstNameLabel: 'Vorname',
    lastNameLabel: 'Nachname',
    emailAddressLabel: 'E-Mail-Adresse',
    addressLabel: 'Adresse *',
    apartmentLabel: 'Apartment, Suite usw.',
    postalCodeLabel: 'Postleitzahl',
    cityLabel: 'Stadt',
    stateLabel: 'Zustand',
    countryLabel: 'Land',
    phoneLabel: 'Telefon (Optional)',
    chooseProductHeader: '🎁 PRODUKTE FÜR GESCHENKE WÄHLEN',
    chooseProductSubTitle: 'Wählen Sie aus diesen Geschenkoptionen Ihren Favoriten!',
    selectProductLabel: 'Produkt auswählen*',
    selectProductPlaceholder: 'Wähle eine Option',
    otherDetailsHeader: '✨ ANDERE DETAILS',
    otherDetailsSubTitle: 'Gibt es sonst noch etwas, das Sie vom Botschafterprogramm erwarten würden?',
    otherDetailsPlaceholder: 'Bitte beantworten Sie die obige Frage...',
    goBackToStoreCta: 'Zurück zum Shop',
    submitApplicationCta: 'Bewerbung einreichen',
    paypalPlaceholder: 'Ihre PayPal-E-Mail',
    venmoPlaceholder: 'Ihre Venmo-E-Mail',
    invalidPaypalEmail: 'Bitte geben Sie eine gültige PayPal-E-Mail-Adresse ein',
    invalidVenmoEmail: 'Bitte geben Sie eine gültige Venmo-E-Mail-Adresse ein',
    applyNowCta: 'Jetzt bewerben!',
    addressPlaceholder: 'e.g. Hotel Riu Plaza Berlin',
    apartmentPlaceholder: 'e.g. Martin-Luther-Str.',
    postalCodePlaceholder: 'e.g. 10777',
    cityPlaceholder: 'e.g. Berlin',
    statePlaceholder: 'e.g. Brandenburg',
    countryPlaceholder: 'e.g. Germany',
    usernamePlaceholder: 'nutzername',
    addressLineOneMinLengthError: 'Die Adresse muss mindestens 4 Zeichen lang sein',
    addressLineOneMaxLengthError: 'Maximale Zeichenanzahl erreicht.',
    applicationAlreadySubmittedHeader: 'Bewerbung bereits eingereicht!',
    applicationAlreadySubmittedSubTitle: 'Sie haben den Antrag bereits eingereicht.',
  },
  spanish: {
    emailPlaceholder: 'Ingrese su correo electrónico',
    formHeader: 'Solicite a continuación y nos comunicaremos con usted👇',
    personalInfoHeader: '✍️ INFORMACIÓN PERSONAL',
    socialMediaHeader: '🔗 ENLACES DE REDES SOCIALES',
    ambassadorQuestionHeader: '💬 PREGUNTAS DEL PROGRAMA DE EMBAJADOR',
    shippingAddressHeader: '🏠 DIRECCIÓN DE ENVÍO PARA REGALOS',
    paymentDetailsHeader: '💰 DETALLES DE PAGO PARA ENVIAR COMISIONES',
    paymentDetailsSubTitle: '¿Seleccionar método de pago e ingresar dirección de correo electrónico?',
    firstNameLabel: 'Nombre',
    lastNameLabel: 'Apellido',
    emailAddressLabel: 'Dirección de correo electrónico',
    addressLabel: 'Dirección',
    apartmentLabel: 'Apartamento, suite, etc',
    postalCodeLabel: 'Código postal',
    cityLabel: 'Ciudad',
    stateLabel: 'Estado',
    countryLabel: 'País',
    phoneLabel: 'Teléfono (opcional)',
    chooseProductHeader: '🎁 ELEGIR PRODUCTOS PARA REGALOS',
    chooseProductSubTitle: '¡Elige tu favorito entre estas opciones de regalo!',
    selectProductLabel: 'Seleccionar producto*',
    selectProductPlaceholder: 'Seleccione una opción',
    otherDetailsHeader: '✨ OTROS DETALLES',
    otherDetailsSubTitle: '¿Algo más que esperarías del programa de embajadores?',
    otherDetailsPlaceholder: 'Por favor responda lo anterior...',
    goBackToStoreCta: 'Volver a la tienda',
    submitApplicationCta: 'Presentar la solicitud',
    paypalPlaceholder: 'Su correo electrónico de PayPal',
    venmoPlaceholder: 'Su correo electrónico de Venmo',
    invalidPaypalEmail: 'Ingrese un correo electrónico de PayPal válido',
    invalidVenmoEmail: 'Ingrese un correo electrónico de Venmo válido',
    applyNowCta: 'Aplica Ahora!',
    addressPlaceholder: 'e.g. Hotel en Tordesillas Real De Castilla',
    apartmentPlaceholder: 'e.g. C. Vista Alegre',
    postalCodePlaceholder: 'e.g. 47100',
    cityPlaceholder: 'e.g. Tordesillas',
    statePlaceholder: 'e.g. Valladolid',
    countryPlaceholder: 'e.g. Spain',
    usernamePlaceholder: 'nombre de usuario',
    addressLineOneMinLengthError: 'La dirección debe tener al menos 4 caracteres',
    addressLineOneMaxLengthError: 'Se alcanzó el límite máximo de caracteres.',
    applicationAlreadySubmittedHeader: '¡Solicitud ya enviada!',
    applicationAlreadySubmittedSubTitle: 'Ya has enviado la solicitud.',
  },
  italian: {
    emailPlaceholder: 'Inserisci la tua email',
    formHeader: 'Fai domanda qui sotto e ti risponderemo👇',
    personalInfoHeader: '✍️ INFORMAZIONI PERSONALI',
    socialMediaHeader: '🔗LINK AI SOCIAL MEDIA',
    ambassadorQuestionHeader: '💬 DOMANDE SUL PROGRAMMA AMBASCIATORE',
    shippingAddressHeader: '🏠 INDIRIZZO DI SPEDIZIONE PER REGALI',
    paymentDetailsHeader: '💰 DETTAGLI PAGAMENTO PER INVIARE COMMISSIONI',
    paymentDetailsSubTitle: "Seleziona il metodo di pagamento e inserisci l'indirizzo email?",
    firstNameLabel: 'Nome',
    lastNameLabel: 'Cognome',
    emailAddressLabel: 'Indirizzo email',
    addressLabel: 'Indirizzo',
    apartmentLabel: 'Appartamento, suite, ecc.',
    postalCodeLabel: 'Codice postale',
    cityLabel: 'Città',
    stateLabel: 'Stato',
    countryLabel: 'Paese',
    phoneLabel: 'Telefono (facoltativo)',
    chooseProductHeader: '🎁 SCEGLI PRODOTTI PER REGALI',
    chooseProductSubTitle: 'Scegli il tuo preferito tra queste opzioni regalo!',
    selectProductLabel: 'Seleziona prodotto*',
    selectProductPlaceholder: "Seleziona un'opzione",
    otherDetailsHeader: '✨ ALTRI DETTAGLI',
    otherDetailsSubTitle: "C'è qualcos'altro che ti aspetteresti dal programma ambasciatore?",
    otherDetailsPlaceholder: 'Per favore rispondi a quanto sopra...',
    goBackToStoreCta: 'Torna al negozio',
    submitApplicationCta: 'Presentare domanda',
    paypalPlaceholder: 'La tua email PayPal',
    venmoPlaceholder: 'La tua email Venmo',
    invalidPaypalEmail: 'Inserisci un indirizzo email PayPal valido',
    invalidVenmoEmail: 'Inserisci un indirizzo email Venmo valido',
    applyNowCta: 'Applica ora!',
    addressPlaceholder: 'e.g. Napoleon Hotel Roma',
    apartmentPlaceholder: 'e.g. P.za Vittorio Emanuele II',
    postalCodePlaceholder: 'e.g. 00185',
    cityPlaceholder: 'e.g. Rome',
    statePlaceholder: 'e.g. Rome',
    countryPlaceholder: 'e.g. Italy',
    usernamePlaceholder: 'nome utente',
    addressLineOneMinLengthError: "L'indirizzo deve contenere almeno 4 caratteri",
    addressLineOneMaxLengthError: 'Limite massimo di caratteri raggiunto.',
    applicationAlreadySubmittedHeader: 'Domanda già inviata!',
    applicationAlreadySubmittedSubTitle: 'Hai già inviato la domanda.',
  },
};
